export const GAME_THEORY_WHEEL_FORCE_MIN = 0;
export const GAME_THEORY_WHEEL_FORCE_MAX = 3;
export const GAME_THEORY_WHEEL_FORCE_STEP = 0.1;
export const GAME_THEORY_WHEEL_DEGREES_PER_FORCE = 90;
export function clampGameTheoryWheelForce(value) {
    if (!Number.isFinite(value)) {
        return GAME_THEORY_WHEEL_FORCE_MIN;
    }
    const stepped = Math.round(value / GAME_THEORY_WHEEL_FORCE_STEP) * GAME_THEORY_WHEEL_FORCE_STEP;
    const clamped = Math.max(GAME_THEORY_WHEEL_FORCE_MIN, Math.min(GAME_THEORY_WHEEL_FORCE_MAX, stepped));
    return Math.round(clamped * 10) / 10;
}
export function gameTheoryWheelRotationDeg(totalForce) {
    const force = Number.isFinite(totalForce) ? Math.max(0, totalForce) : 0;
    return force * GAME_THEORY_WHEEL_DEGREES_PER_FORCE;
}
/** Maps a clockwise-from-12-o'clock angle onto a sector centered at i * (360/n). */
export function playerIdAtWheelAngle(sectorPlayerIds, angleDeg) {
    const n = sectorPlayerIds.length;
    if (n === 0) {
        return '';
    }
    const sectorWidth = 360 / n;
    const normalized = ((angleDeg % 360) + 360) % 360;
    const shifted = (normalized + sectorWidth / 2) % 360;
    const index = Math.min(n - 1, Math.floor(shifted / sectorWidth));
    return sectorPlayerIds[index] ?? '';
}
export function wheelAskerAndAnswerer(sectorPlayerIds, finalAngleDeg) {
    return {
        askerId: playerIdAtWheelAngle(sectorPlayerIds, finalAngleDeg),
        answererId: playerIdAtWheelAngle(sectorPlayerIds, finalAngleDeg + 180),
    };
}
export function normalizeWheelAngleDeg(angleDeg) {
    return ((angleDeg % 360) + 360) % 360;
}
export function gameTheoryWheelSpinDurationMs(totalForce) {
    const force = Math.max(0, totalForce);
    return Math.max(800, Math.min(4500, 800 + force * 400));
}
export function easeOutCubic(t) {
    const x = Math.max(0, Math.min(1, t));
    return 1 - (1 - x) ** 3;
}
export function interpolateWheelRotationDeg(totalRotationDeg, startedAt, endsAt, now) {
    const duration = Math.max(1, endsAt - startedAt);
    const t = Math.max(0, Math.min(1, (now - startedAt) / duration));
    return totalRotationDeg * easeOutCubic(t);
}
//# sourceMappingURL=gameTheoryWheel.js.map